<template>
  <b-overlay
    :show="isLoading"
    :opacity="0.75"
    variant="white"
    spinner-variant="primary"
    spinner-type="border"
    blur="3px"
  >
    <slot />
    <template #overlay>
      <div class="d-flex text-center">
        <b-spinner class="align-middle" variant="primary" :small="small"></b-spinner>
        <slot name="info"></slot>
      </div>
    </template>
  </b-overlay>
</template>
<script>
export default {
  name: 'gloading',
  props: {
    name: [String, Array],
    loading: Boolean,
    small: false
  },
  computed: {
    isLoading() {
      return this.loading || this.$util.gloading.isLoading(this.name);
    }
  }
};
</script>
